import { render, staticRenderFns } from "./InviteProject.vue?vue&type=template&id=66bb95b8"
import script from "./InviteProject.vue?vue&type=script&lang=js"
export * from "./InviteProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports